import cookie from 'vue-cookies'

export default () => ({
        // token: cookie.get('token'),
        token: localStorage.getItem('token'),
        // user: cookie.get('user')  ,
        user: JSON.parse(localStorage.getItem('user')) ,
        current_user: null,
        isUserLoggedIn: false,
        isExistAccessToken: false,
        password: '',
        oldPassword:'',
        confirmation:'',
    })
